const ArrowLightDown = ({
    color = '#252525',
    width = 14,
    height = 8,
    style,
    data,
    className,
  }) => {
    return (
      <svg
        style={style}
        width={width}
        height={height}
        viewBox="0 0 14 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-icon={data}
        className={className}
      >
        <path
          d="M13 1L7 7L1 1"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
  
  export default ArrowLightDown
  